import * as React from "react";

export const HideableComponentWrapper = (
  InputComponent: React.ComponentType<any>
) => {
  interface HideableComponentProps {
    isHidden: boolean;
  }
  class HideableComponent extends React.Component<HideableComponentProps> {
    constructor(props: any) {
      super(props);
    }
    public render() {
      const { isHidden, ...passThroughProps } = this.props;

      return (
        <div
          style={{
            visibility: isHidden ? "hidden" : "visible"
          }}
        >
          <InputComponent {...passThroughProps} />
        </div>
      );
    }
  }
  return HideableComponent;
};



// WEBPACK FOOTER //
// ./src/shared/HideableComponent.tsx